<template>
  <div class="white-bg pb-5 mb-4">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6 mt-20 pt-4">
        <h5>Pesquise pela NCM Completa</h5>
      </div>
      <div class="col-md-3"></div>
    </div>
    <div class="row mb-50">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="input-group inputclasse">
          <input
            type="text"
            class="form-control"
            placeholder="Ex. 0000.00.00"
            aria-label
            aria-describedby="basic-addon1"
            v-model="pesquisa"
            @keyup.enter="pesquisar()"
            @keypress="mascara()"
            maxlength="10"
            :readonly="this.$store.state.idCliente == '9475'"
          />
          <div class="input-group-prepend">
            <button class="btn btn-labeled btn-info" @click="pesquisar()" type="button">
              Pesquisar
              <div
                class="spinner-border text-white loading ml-2"
                v-if="loadingPesquisa"
                role="status"
              >
                <span class="sr-only">Aguarde...</span>
              </div>
            </button>
          </div>
        </div>
        <span class="erro" v-if="validacaoNcm">O número da NCM deve conter 8 dígitos</span>
      </div>
      <div class="col-md-3"></div>
    </div>
    <p class="fs-12 texto-italico m-auto w-70 box-nota p-2 centralizar">
      <strong>NOTA LEFISC:</strong><br/>
      <span class="d-inline-block mb-1 mt-1" v-html="titulo"></span>
     
    </p>
    <nao-encontrada />
  </div>
</template>

<script>
import serviceHistorico from "../../services/ServiceHistorico";

import modalNaoEncontrada from "../../shared/modalNaoEncontrada";
import config from '../../services/config';
export default {
  components: {
    "nao-encontrada": modalNaoEncontrada
  },
  data() {
    return {
      pesquisa: "",
      validacaoNcm: false,
      mensagemErro: "",
      loadingPesquisa: false,
      mascaraTeste: null,
      titulo:""
    };
  },
  methods: {
    async pesquisar() {
      if (this.pesquisa.length == 10) {
        this.validacaoNcm = false;
        this.loadingPesquisa = true;
        await serviceHistorico.getDadosNCM(this.pesquisa).then(
          res => {
            this.loadingPesquisa = false;
            if (res == "NCM não encontrada!") {
              this.$bvModal.show("ncmNaoEncontrada");
              this.mensagemErro = res;
            } else {
              this.$router.push({
                name: "Histórico",
                params: { ncm: this.pesquisa }
              });
            }
          },
          err => {
            this.loadingPesquisa = false;
            console.error("nao foi possivel obter dados do servidor");
          }
        );
      } else {
        this.validacaoNcm = true;
      }
    },
    async getTitulo(){
      this.titulo = await config.getTitulo()
    },
    mascara() {
      setTimeout(() => {
        this.pesquisa = this.pesquisa.replace(/\D/g, "");
        this.pesquisa = this.pesquisa.replace(/(\d{4})/, "$1.");
        this.pesquisa = this.pesquisa.replace(/(\d{4}).(\d{2})/g, "$1.$2.");
      }, 0.1);
    }
  },
  created(){
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
this.$store.state.idCliente =  getCookie("idCliente")
     if(this.$store.state.idCliente == '9475'){
      this.pesquisa = '8708.10.00'   
    }
  },
  mounted(){
   
    this.getTitulo()
  }
};
</script>

<style scoped>
.erro {
  color: red;
}

.fs-12 {
  font-size: 12px;
}

.w-70 {
  width: 70%;
}


.centralizar {
  line-height: 150px;
}

.texto-italico {
  font-style: italic;
  line-height: 15px;
  text-align: justify;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}
@media (max-width: 425px) {
  h5 {
    font-size: 16px;
    padding-left: 15px;
  }
  .inputclasse {
    margin-left: 15px;
    width: 90%;
  }
}
</style>